import { useEffect, useState } from "react";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
// import { GetItemType } from '../../../Redux/Reducers/BudgetInformation/ObjectivesActivities'
import "./style.css";
import {
  AdministrativeCosts,
  EditAdministrativeCostsAndMonth,
  filterItemTypeAdministrativeCostsBudget,
  GetAdministrativeCostsAndMonthById,
  GetBI_AB_ItemTypeAdministrativeCostsBudget,
  setClearValidationAdministrativeCosts,
  ValidationAdministrativeCosts,
} from "../../../Redux/Reducers/BudgetInformation/AdministrativeCosts";
import { useDispatch, useSelector } from "react-redux";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import InputAHSF from "../../../Components/InputAHSF";
import MonthsImplementationDirectBudgetCosts from "../BudgetDirectCosts/MonthsImplementationDirectBudgetCosts";
import $ from "jquery";
import { GetBI_TimelineInformation } from "../../../Redux/Reducers/BudgetInformation/TimelineInformation";
import { setRefreshTable } from "../../../Redux/Reducers/VariousVariables";
import Swal from "sweetalert2";
import { decryptToken } from "../../../Services/Account/EncryptionParams";
import { useParams } from "react-router-dom";

const BudgetAdministrativeCostsAddEdit = (props) => {
  const ItemTypeAdministrativeCostsBudgetList = useSelector(
    (state) => state.administrativeCosts.ItemTypeAdministrativeCostsBudget
  );
  const AdministrativeCostsBudgetAndMonth = useSelector(
    (state) => state.administrativeCosts.AdministrativeCostsBudgetAndMonth
  );
  const ItemTypeAdministrativeCostsBudget = useSelector(
    (state) => state.administrativeCosts.ItemTypeAdministrativeCostsBudgetFilter
  );
  const lodingAdministrativeCostsBudgetAndMonth = useSelector(
    (state) => state.administrativeCosts.lodingAdministrativeCostsBudgetAndMonth
  );
  const valudationStatus = useSelector(
    (state) => state.administrativeCosts.ValidationAdministrativeCosts
  );
  const valudationLoding = useSelector(
    (state) => state.administrativeCosts.lodingValidationAdministrativeCosts
  );
  const [bI_AB_ItemTypeId, setBI_AB_ItemTypeId] = useState(null);
  const [itemName, setItemName] = useState(null);
  const [descriptionDetailsOfItem, setDescriptionDetailsOfItem] =
    useState(null);
  const [numberOfUnits, setNumberOfUnits] = useState(null);
  const [unitPrice, setUnitPrice] = useState(null);
  const [frequency, setFrequency] = useState(null);

  const [beneficiaryContribution, setBeneficiaryContribution] = useState(null);
  const [shomanContribution, setShomanContribution] = useState(null);
  const [total, setTotal] = useState(null);
  const [AI_ApplicationInformationId, setAI_ApplicationInformationId] =
    useState(null);
  const [dataEditMonth, setDataEditMonth] = useState([]);
  const [showMessageMonth, setShowMessageMonth] = useState(false);
  const JsonDataa = useSelector((state) => state.FetchDataJson);
  // const TimelineInformationChange = useSelector((state) => state.BI_TimelineInformation.EditBI_TimelineInformation)
  const dispatch = useDispatch();
  const AppGuid = useParams();

  useEffect(() => {
    dispatch(GetBI_AB_ItemTypeAdministrativeCostsBudget());
  }, []);
  ///////////////////////////////////////////////////////////////////////////////////////////////////////
  const TimelineInformation = useSelector(
    (state) => state.BI_TimelineInformation?.BI_TimelineInformation
  );
  //array for monthes dropdown data
  const arrayOfMonths = [
    {
      numberOfMonth: 1,
      nameMonth: "الشهر الأول",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 2,
      nameMonth: "الشهر الثاني",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 3,
      nameMonth: "الشهر الثالث",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 4,
      nameMonth: "الشهر الرابع",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 5,
      nameMonth: "الشهر الخامس",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 6,
      nameMonth: "الشهر السادس",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 7,
      nameMonth: "الشهر السابع",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 8,
      nameMonth: "الشهر الثامن",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 9,
      nameMonth: "الشهر التاسع",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 10,
      nameMonth: "الشهر العاشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 11,
      nameMonth: "الشهر الحادي عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 12,
      nameMonth: "الشهر الثاني عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 13,
      nameMonth: "الشهر الثالث عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 14,
      nameMonth: "الشهر الرابع عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 15,
      nameMonth: "الشهر الخامس عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 16,
      nameMonth: "الشهر السادس عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 17,
      nameMonth: "الشهر السابع عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 18,
      nameMonth: "الشهر الثامن عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 19,
      nameMonth: "الشهر التاسع عشر",
      totalValue: 0,
      isChecked: false,
    },
  ];

  useEffect(() => {
    dispatch(setClearValidationAdministrativeCosts());
  }, []);
  //to get data for GetBI_TimelineInformation by aI_ApplicationInformationId or param
  useEffect(() => {
    dispatch(
      GetBI_TimelineInformation(props.PlaceOfCall == "InformationAdministrativeCosts" ? props.aI_ApplicationInformation :
        localStorage.getItem("aI_ApplicationInformationId") ||
        decryptToken(AppGuid.AppGuid)
      )
    );
  }, []);

  let arrayOfMonthsFilter = arrayOfMonths.slice(
    0,
    TimelineInformation?.bI_ImplementationDurationMonths
      ?.implementationDurationMonths
  );
  //to get monthes number from table
  const [arrayOfMonthsFilterAdd, setarrayOfMonthsFilterAdd] = useState(
    arrayOfMonths.slice(
      0,
      TimelineInformation?.bI_ImplementationDurationMonths
        ?.implementationDurationMonths
    )
  );

  ////////////////////////////////////////
  const [factorial, setFactorial] = useState();
  const [factorialMinus, setFactorialMinus] = useState();

  ////////////////////////////////////////

  //////////////////////////////////////

  /////////////////////////////////////
  //////////////////////////////////assining Data//////////////////////////////////////////////////


  //if in update or view mood assining data for felds
  useEffect(() => {
    if (props.Action == "view" || props.Action == "edit" || props.PlaceOfCall == "InformationAdministrativeCosts") {
      setBI_AB_ItemTypeId(
        AdministrativeCostsBudgetAndMonth
          ?.estimatedBudgetForAdministrativeCostsFilter
          ?.bI_AB_ItemTypeAdministrativeCostsBudgetId
      );
      setItemName(
        AdministrativeCostsBudgetAndMonth
          ?.estimatedBudgetForAdministrativeCostsFilter?.itemName
      );
      setDescriptionDetailsOfItem(
        AdministrativeCostsBudgetAndMonth
          ?.estimatedBudgetForAdministrativeCostsFilter
          ?.descriptionDetailsOfItem
      );
      setNumberOfUnits(
        AdministrativeCostsBudgetAndMonth
          ?.estimatedBudgetForAdministrativeCostsFilter?.numberOfUnits
      );
      setUnitPrice(
        AdministrativeCostsBudgetAndMonth
          ?.estimatedBudgetForAdministrativeCostsFilter?.unitPrice
      );
      setFrequency(
        AdministrativeCostsBudgetAndMonth
          ?.estimatedBudgetForAdministrativeCostsFilter?.frequency
      );
      setBeneficiaryContribution(
        AdministrativeCostsBudgetAndMonth
          ?.estimatedBudgetForAdministrativeCostsFilter?.beneficiaryContribution
      );
      setShomanContribution(
        AdministrativeCostsBudgetAndMonth
          ?.estimatedBudgetForAdministrativeCostsFilter?.shomanContribution
      );
      setTotal(
        AdministrativeCostsBudgetAndMonth
          ?.estimatedBudgetForAdministrativeCostsFilter?.total
      );
      dispatch(
        filterItemTypeAdministrativeCostsBudget(
          parseInt(
            AdministrativeCostsBudgetAndMonth
              ?.estimatedBudgetForAdministrativeCostsFilter
              ?.bI_AB_ItemTypeAdministrativeCostsBudgetId
          )
        )
      );
    }
  }, [AdministrativeCostsBudgetAndMonth]);
  //
  useEffect(() => {
    setFactorial(
      (!isNaN(numberOfUnits) && numberOfUnits ? numberOfUnits : 0) *
      (!isNaN(frequency) && frequency ? frequency : 0) *
      (!isNaN(unitPrice) && unitPrice ? unitPrice : 0)
    );
  }, [numberOfUnits, frequency, unitPrice]);
  //لحساب مساهمة المستفيد في حال اختيار نوع نشاط
  useEffect(() => {
    setFactorialMinus(
      (factorial != undefined ? factorial : 0) -
      (!isNaN(beneficiaryContribution) && beneficiaryContribution
        ? beneficiaryContribution
        : 0)
    );
  }, [factorial, beneficiaryContribution]);
  /////////////////////////////////////////////////////////////////////////////////
  //to add data on AdministrativeCosts table
  const AddEstimatedBudgetForAdministrativeCosts = () => {
    dispatch(
      AdministrativeCosts({
        estimatedBudgetForAdministrativeCosts: {
          bI_AB_ItemTypeAdministrativeCostsBudgetId: bI_AB_ItemTypeId,
          itemName: itemName,
          descriptionDetailsOfItem: descriptionDetailsOfItem,
          numberOfUnits: numberOfUnits,
          unitPrice: unitPrice,
          frequency: frequency,
          beneficiaryContribution:
            ItemTypeAdministrativeCostsBudget?.applyCondition
              ? factorial
              : beneficiaryContribution,
          shomanContribution: ItemTypeAdministrativeCostsBudget?.applyCondition
            ? 0
            : factorialMinus,
          total: factorial,
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId"
          ),
        },
        bI_AB_DistributionOfAdministrativeCostsBudgetList:
          arrayOfMonthsFilterAdd,
      })
    );
    Swal.fire({
      position: "center",
      icon: "success",
      title: "تم اضافة المعلومات بنجاح",
      showConfirmButton: false,
      timer: 1500,
      // width: "500px",
    });
    $(".close-btn").trigger("click");
  };
  //to update data on AdministrativeCosts table
  const EditAdministrativeCostsAndMonthFun = async () => {


    const edit = await dispatch(
      EditAdministrativeCostsAndMonth({
        bI_AB_EstimatedBudgetForAdministrativeCostsEditModel: {
          bI_AB_EstimatedBudgetForAdministrativeCostsId:
            props.estimatedBudgetForAdministrativeCostsId,
          bI_AB_ItemTypeAdministrativeCostsBudgetId: bI_AB_ItemTypeId,
          itemName: itemName,
          descriptionDetailsOfItem: descriptionDetailsOfItem,
          numberOfUnits: numberOfUnits,
          unitPrice: unitPrice,
          frequency: frequency,
          beneficiaryContribution:
            ItemTypeAdministrativeCostsBudget?.applyCondition
              ? factorial
              : beneficiaryContribution,
          shomanContribution: ItemTypeAdministrativeCostsBudget?.applyCondition
            ? 0
            : factorialMinus,
          total: factorial,
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId"
          ),
        },
        bI_AB_DistributionOfAdministrativeCostsBudgetEditModel: dataEditMonth,
      })
    );
    if (edit) {
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      //refresh table 
      dispatch(setRefreshTable());
    }
  };

  useEffect(() => {
    if (props.ViewData || props.PlaceOfCall == "InformationAdministrativeCosts") {
      if (props.PlaceOfCall == "InformationAdministrativeCosts") {
        dispatch(
          GetAdministrativeCostsAndMonthById({
            bI_AB_EstimatedBudgetForAdministrativeCostsId:
              props.bI_AB_EstimatedBudgetForAdministrativeCostsId,
          })
        );
      } else {
        dispatch(
          GetAdministrativeCostsAndMonthById({
            bI_AB_EstimatedBudgetForAdministrativeCostsId:
              props.estimatedBudgetForAdministrativeCostsId,
          })
        );
      }

    }
  }, []);

  //add comma on numbers
  const numberWithCommas = (x) => {
    x = x != undefined ? x : "";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  //for validation on table 
  const validation = async () => {
    const validate = await dispatch(
      ValidationAdministrativeCosts({
        bI_AB_ItemTypeAdministrativeCostsBudgetId: bI_AB_ItemTypeId,
        itemName: itemName,
        descriptionDetailsOfItem: descriptionDetailsOfItem,
        numberOfUnits: numberOfUnits,
        unitPrice: unitPrice,
        frequency: frequency,
        beneficiaryContribution: beneficiaryContribution,
        shomanContribution: ItemTypeAdministrativeCostsBudget?.applyCondition
          ? 0
          : factorialMinus,
        total: factorial,
        aI_ApplicationInformationId: localStorage.getItem(
          "aI_ApplicationInformationId"
        ),
        bI_AB_DistributionOfAdministrativeCostsBudgetList:
          props.Action == "add" ? arrayOfMonthsFilterAdd : dataEditMonth,
      })
    );
    //after validation ends get action
    if (validate.payload) {
      //console.log(validate.payload, "ssssdsdsdsdsd");
      let endLoop = false;

      let sumMonth = 0;
      if (props.Action == "add") {
        const sum = arrayOfMonthsFilterAdd.reduce((accumulator, current) => {
          const value = parseFloat(current.totalValue);
          if (!isNaN(value)) {
            return accumulator + value;
          }
          return accumulator; // تخطي القيم غير الرقمية
        }, 0); // القيمة الابتدائية هي 0
        sumMonth = sum;
        endLoop = true;
      } else if (props.Action == "edit") {
        const sum = dataEditMonth.reduce((accumulator, current) => {
          const value = parseFloat(current.totalValue);
          if (!isNaN(value)) {
            return accumulator + value;
          }
          return accumulator; // تخطي القيم غير الرقمية
        }, 0); // القيمة الابتدائية هي 0
        sumMonth = sum;
        endLoop = true;
      }

      //validation on monthes
      if (endLoop) {
        if (
          sumMonth !=
          (ItemTypeAdministrativeCostsBudget?.applyCondition
            ? 0
            : factorialMinus)
          //       &&
          //   props.Action != "edit"
        ) {
          setShowMessageMonth(true);
        } else {
          if (props.Action == "edit" && validate.payload.length === 0) {
            EditAdministrativeCostsAndMonthFun();
          } else {
            if (validate?.payload?.length === 0) {
              AddEstimatedBudgetForAdministrativeCosts();
            }
          }
          setShowMessageMonth(false);
        }
      }
    }
  };
  // console.log(arrayOfMonthsFilterAdd,"ssssssdwdwdwd");
  
  //render html
  let Html = (
    <>
      <div className="containerAdministrativeCostsAddEdit">
        <div className="FirstRow">
          <AllDropDownsAHSF
            fieldsName="ItemType"
            show={true}
            disabled={props.disabledData|| props.PlaceOfCall == "InformationAdministrativeCosts"? true : false}
            dropdownType="normal"
            arrayOoptionList={ItemTypeAdministrativeCostsBudgetList}
            KeyText={"itemTypeNameAr"}
            KeyValue={"bI_AB_ItemTypeAdministrativeCostsBudgetId"}
            defaultValue={
              props.Action == "view" || props.Action == "edit" || props.PlaceOfCall == "InformationAdministrativeCosts"
                ? AdministrativeCostsBudgetAndMonth
                  ?.estimatedBudgetForAdministrativeCostsFilter
                  ?.bI_AB_ItemTypeAdministrativeCostsBudgetId
                : ""
            }
            onChange={(e) => {
              setBI_AB_ItemTypeId(parseInt(e.target.value));
              dispatch(
                filterItemTypeAdministrativeCostsBudget(
                  parseInt(e.target.value)
                )
              );
              if (ItemTypeAdministrativeCostsBudget?.applyCondition) {
                setBeneficiaryContribution(0);
              }
            }}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              valudationStatus ? valudationStatus.includes("ItemType") : false
            }
          />

          <InputAHSF
            fieldsName="ItemNameAdminstrativeCost"
            show={true}
            disabled={props.disabledData|| props.PlaceOfCall == "InformationAdministrativeCosts" ? true : false}
            defaultValue={
              props.Action == "view" || props.Action == "edit" || props.PlaceOfCall == "InformationAdministrativeCosts"
                ? AdministrativeCostsBudgetAndMonth
                  ?.estimatedBudgetForAdministrativeCostsFilter?.itemName
                : ""
            }
            onChange={(e) => {
              setItemName(e.target.value);
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}

            validationMessage={"حقل اجباري"}
            showValidationMessage={
              valudationStatus ? valudationStatus.includes("ItemName") : false
            }
          />

          <InputAHSF
            fieldsName="DescriptionDetailsOfItem"
            show={true}
            disabled={props.disabledData || props.PlaceOfCall == "InformationAdministrativeCosts"? true : false}
            defaultValue={
              props.Action == "view" || props.Action == "edit" || props.PlaceOfCall == "InformationAdministrativeCosts"
                ? AdministrativeCostsBudgetAndMonth
                  ?.estimatedBudgetForAdministrativeCostsFilter
                  ?.descriptionDetailsOfItem
                : ""
            }
            onChange={(e) => {
              setDescriptionDetailsOfItem(e.target.value);
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}

            validationMessage={"حقل اجباري"}
            showValidationMessage={
              valudationStatus
                ? valudationStatus.includes("DescriptionDetailsOfItem")
                : false
            }
          />
        </div>
        <div className="SecondRow">
          <InputAHSF
            fieldsName="NumberOfUnits"
            comma={true}
            show={true}
            disabled={props.disabledData || props.PlaceOfCall == "InformationAdministrativeCosts"? true : false}
            defaultValue={
              props.Action == "view" || props.Action == "edit" || props.PlaceOfCall == "InformationAdministrativeCosts"
                ? numberWithCommas(
                  AdministrativeCostsBudgetAndMonth
                    ?.estimatedBudgetForAdministrativeCostsFilter
                    ?.numberOfUnits
                )
                : ""
            }
            onChange={(e) => {
              setNumberOfUnits(parseFloat(e.target.value.replace(",", "")));
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              valudationStatus
                ? valudationStatus.includes("NumberOfUnits")
                : false
            }
          />
          <InputAHSF
            fieldsName="UnitPrice"
            comma={true}
            show={true}
            disabled={props.disabledData || props.PlaceOfCall == "InformationAdministrativeCosts"? true : false}
            defaultValue={
              props.Action == "view" || props.Action == "edit" || props.PlaceOfCall == "InformationAdministrativeCosts"
                ? numberWithCommas(
                  AdministrativeCostsBudgetAndMonth
                    ?.estimatedBudgetForAdministrativeCostsFilter?.unitPrice
                )
                : ""
            }
            onChange={(e) => {
              setUnitPrice(parseFloat(e.target.value.replace(",", "")));
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}

            validationMessage={"حقل اجباري"}
            showValidationMessage={
              valudationStatus ? valudationStatus.includes("UnitPrice") : false
            }
          />
          <InputAHSF
            fieldsName="Frequency"
            comma={true}
            show={true}
            disabled={props.disabledData || props.PlaceOfCall == "InformationAdministrativeCosts"? true : false}
            defaultValue={
              props.Action == "view" || props.Action == "edit" || props.PlaceOfCall == "InformationAdministrativeCosts"
                ? numberWithCommas(
                  AdministrativeCostsBudgetAndMonth
                    ?.estimatedBudgetForAdministrativeCostsFilter?.frequency
                )
                : ""
            }
            onChange={(e) => {
              setFrequency(parseFloat(e.target.value.replace(",", "")));
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}

            validationMessage={"حقل اجباري"}
            showValidationMessage={
              valudationStatus ? valudationStatus.includes("Frequency") : false
            }
          />
        </div>
        <div className="ThirdRow">
          <InputAHSF
            fieldsName="BeneficiaryContribution"
            comma={true}
            show={true}
            disabled={
              props.disabledData|| props.PlaceOfCall == "InformationAdministrativeCosts"
                ? true
                : ItemTypeAdministrativeCostsBudget?.applyCondition
                  ? true
                  : false
            }
            defaultValue={
              props.Action == "view" || props.Action == "edit" || props.PlaceOfCall == "InformationAdministrativeCosts"
                ? AdministrativeCostsBudgetAndMonth
                  ?.estimatedBudgetForAdministrativeCostsFilter
                  ?.beneficiaryContribution
                : ""
            }
            value={
              ItemTypeAdministrativeCostsBudget?.applyCondition
                ? numberWithCommas(factorial)
                : numberWithCommas(beneficiaryContribution)
            }
            onChange={(e) => {
              //console.log(beneficiaryContribution, "sdssssssss");

              setBeneficiaryContribution(
                parseFloat(
                  e.target.value && !isNaN(beneficiaryContribution)
                    ? e.target.value.replace(",", "")
                    : 0
                )
              );
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}

            validationMessage={"حقل اجباري"}
            showValidationMessage={
              valudationStatus
                ? valudationStatus.includes("BeneficiaryContribution")
                : false
            }
          />
          <InputAHSF
            fieldsName="ShomanContribution"
            show={true}
            disabled={true}
            defaultValue={
              props.Action == "view" || props.Action == "edit" || props.PlaceOfCall == "InformationAdministrativeCosts"
                ? AdministrativeCostsBudgetAndMonth
                  ?.estimatedBudgetForAdministrativeCostsFilter
                  ?.shomanContribution
                : ""
            }
            value={
              ItemTypeAdministrativeCostsBudget?.applyCondition
                ? 0
                : numberWithCommas(factorialMinus)
            }
            onChange={(e) => {
              setShomanContribution(
                parseFloat(e.target.value.replace(",", ""))
              );
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}

            validationMessage={"حقل اجباري"}
            showValidationMessage={
              valudationStatus
                ? valudationStatus.includes("ShomanContribution")
                : false
            }
          />

          <InputAHSF
            fieldsName="Total"
            show={true}
            disabled={true}
            value={numberWithCommas(factorial)}
            onChange={(e) => {
              setTotal(parseFloat(e.target.value.replace(",", "")));
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}

            validationMessage={"حقل اجباري"}
            showValidationMessage={
              valudationStatus ? valudationStatus.includes("Total") : false
            }
          />
        </div>
        <div className="validationMessageMonyh">
          {showMessageMonth ? <>{JsonDataa.JsonData?.MessageMonth}</> : <></>}
          <br></br>
          <br></br>
          {valudationStatus && valudationStatus.includes("monthes") ? (
            <>يجب اختيار شهر واحد على الاقل</>
          ) : (
            <></>
          )}
          {valudationStatus &&
            valudationStatus.includes("ShomanContribution") ? (
            <>يجب أن تكون قيمة مساهمة شومان أكبر من أو تساوي صفر</>
          ) : (
            <></> 
          )}
        </div>

        {TimelineInformation?.bI_ImplementationDurationMonthsId ? (
          <MonthsImplementationDirectBudgetCosts
            setDataEditMonth={setDataEditMonth}
            setarrayOfMonthsFilterAdd={setarrayOfMonthsFilterAdd}
            action={props.PlaceOfCall == "InformationAdministrativeCosts"?"view": props.Action}
            data={
              props.PlaceOfCall == "InformationAdministrativeCosts"?AdministrativeCostsBudgetAndMonth?.bI_AB_DistributionOfAdministrativeCostsBudgetList?.slice(props.startMonth, props.endMonth):
              props.monthDataApi
                ? AdministrativeCostsBudgetAndMonth?.bI_AB_DistributionOfAdministrativeCostsBudgetList
                : arrayOfMonthsFilterAdd
            }
          />
        ) : (
          <p style={{ color: "red", marginRight: "30px" }}>
            يجب اختيار مدة التنفيذ(الاشهر) لأظهار الشهور
          </p>
        )}
      </div>

      {props.Action == "view"|| props.PlaceOfCall == "InformationAdministrativeCosts" ? (
        <></>
      ) : (
        <>
          <div className="containerButton">
            <ButtonAHSF onClick={validation} text={"حفظ"} show={true} />
          </div>
        </>
      )}
    </>
  );
  //render html after loding ends
  return (
    <>
      {(props.Action == "view" || props.Action == "edit" || props.PlaceOfCall == "InformationAdministrativeCosts") &&
        AdministrativeCostsBudgetAndMonth?.estimatedBudgetForAdministrativeCostsFilter &&
        !lodingAdministrativeCostsBudgetAndMonth &&
        AdministrativeCostsBudgetAndMonth?.bI_AB_DistributionOfAdministrativeCostsBudgetList ? (
        Html
      ) : (
        <>{props.Action == "add" ? Html : <></>}</>
      )}

    </>
  );
};

export default BudgetAdministrativeCostsAddEdit;
